// removed by extract-text-webpack-plugin
module.exports = {"horizontal":"O2IaJ","vertical":"_1H6Sn","bullet":"_1i8oU"};


//////////////////
// WEBPACK FOOTER
// ./app/components/separator/separator.scss
// module id = 650
// module chunks = 3 4 5 6 7